// See https://app.taricsupport.com/#!/search/ccc-conclusions?orderBy=relevance&includeBtis=true&includeClassificationRegulations=true&query=toy&commodityCode=
module.exports = {
    AmendedBy: 'Amended by',
    AmendmentOf: 'Amendment of',
    CccConclusions: 'CCC Conclusions', // CCC = Customs Code Committee
    Documents: 'Documents',
}